/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_EtlInputs */

const en_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const ar_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخراج وتحويل وتحميل`)
};

const bn_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const de_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const es_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const fr_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const pt_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const zh_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const tr_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const ru_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

const pl_svchip_etl = /** @type {(inputs: Svchip_EtlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETL`)
};

/**
* | output |
* | --- |
* | "ETL" |
*
* @param {Svchip_EtlInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_etl = /** @type {((inputs?: Svchip_EtlInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_EtlInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_etl(inputs)
	if (locale === "bn") return bn_svchip_etl(inputs)
	if (locale === "de") return de_svchip_etl(inputs)
	if (locale === "es") return es_svchip_etl(inputs)
	if (locale === "fr") return fr_svchip_etl(inputs)
	if (locale === "pt") return pt_svchip_etl(inputs)
	if (locale === "zh") return zh_svchip_etl(inputs)
	if (locale === "tr") return tr_svchip_etl(inputs)
	if (locale === "ru") return ru_svchip_etl(inputs)
	if (locale === "pl") return pl_svchip_etl(inputs)
	return en_svchip_etl(inputs)
});